import { environments } from 'environments/environments';
import React from 'react';
import { Link } from 'react-router-dom';
import './ContactSection.css';

const contactSection = () => { 
  document.title = environments.pageTitle +  ' - Kontakt';

  return (
    <div className="kontakt">
      <div className="pro-poradatele">
        <p>Jestliže jste produkčním klubu, manažerem nebo pořadatelem festivalů a&nbsp;podobných akcí a máte zájem o vystoupení kapely Doktor Triceratops,</p>
        <p>kontaktujte nás na tel. čísle 604&nbsp;700&nbsp;624</p>
      </div>
      <div className="dotazy-a-pripominky">
        Dotazy, připomínky, náměty, pochvaly a veškerou korespondenci můžete psát emailem na adresu: randy@volny.cz<br />
        Emaily jednotlivých členů souboru najdete u jejich jména v sekci <b><Link to="/kapela">KAPELA</Link></b><br />
        nebo využijte klasickou poštu a pište na adresu:
      </div>
      <div className="vizitka">
        <b>Doktor Triceratops</b><br />
        Ohradní 28<br />
        Praha 4 - Michle<br />
        140 00
      </div>
      <div className="randy">
        604 700 624<br />
        randy@volny.cz
      </div>
      <div className="upozorneni">
        Upozornění: Na veškeré Vaše negativní připomínky se vyignorujeme. Děkujeme za pochopení. :)
      </div>
    </div>
  );
}

export default contactSection;